export interface TrendPoint {
  [key: string]: number | string | null | undefined;
}

export interface TrendSeries {
  suffix: string;
}

export interface TrendBadgeData {
  value: string;
  isPositive: boolean;
}

const DEFAULT_SERIES: TrendSeries[] = [{ suffix: "" }];

const getPointAverage = ({
  point,
  brandId,
  dataSeries = DEFAULT_SERIES,
}: {
  point: TrendPoint;
  brandId: string;
  dataSeries?: TrendSeries[];
}): number | null => {
  const values = dataSeries
    .map((series) => point[`${brandId}${series.suffix}`])
    .filter((value): value is number => typeof value === "number");

  if (values.length === 0) {
    return null;
  }

  return values.reduce((sum, value) => sum + value, 0) / values.length;
};

export const calculateTrendFromPreviousPoint = ({
  chartData,
  brandId,
  dataSeries,
  yAxisReversed = false,
}: {
  chartData: TrendPoint[];
  brandId: string;
  dataSeries?: TrendSeries[];
  yAxisReversed?: boolean;
}): TrendBadgeData | null => {
  if (chartData.length < 2) {
    return null;
  }

  const previousPoint = chartData[chartData.length - 2];
  const currentPoint = chartData[chartData.length - 1];

  const previousValue = getPointAverage({ point: previousPoint, brandId, dataSeries });
  const currentValue = getPointAverage({ point: currentPoint, brandId, dataSeries });

  if (previousValue === null || currentValue === null || previousValue === 0) {
    return null;
  }

  const percentChange = ((currentValue - previousValue) / previousValue) * 100;

  return {
    value: Math.abs(percentChange).toFixed(1),
    isPositive: yAxisReversed ? percentChange < 0 : percentChange > 0,
  };
};
